<template>
  <div>
    <q4cl-card>
      <div class="flex items-start justify-between gap-2 mb-4">
        <h1 class="text-2xl font-bold text-q4cl-primary">{{ $t('セキュア問診票の使い方') }}</h1>
        <!-- 戻る: 問診票閲覧中 (?hash=... / ?debug=true) からの遷移時のみ表示。
             戻り先が無い直アクセスでは非表示 (案内画面廃止のため)。 -->
        <router-link
          v-if="hasContext"
          :to="{ path: '/', query: $route.query }"
          class="btn-secondary !py-1 !px-3 text-xs whitespace-nowrap no-underline shrink-0"
          :aria-label="$t('使い方を閉じて問診票に戻る')"
        >
          <i class="fa-solid fa-xmark mr-1" aria-hidden="true"></i>{{ $t('問診票に戻る') }}
        </router-link>
      </div>
      <div class="space-y-5 text-sm leading-relaxed text-q4cl-ink">
        <section>
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-qrcode text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('アクセス方法') }}</span>
          </h2>
          <p>{{ $t('医療機関から渡された QR コードをスマートフォンで読み取るか、URL に「?hash=...」を付けてアクセスしてください。') }}</p>
        </section>

        <section>
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-shield-halved text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('セキュリティ') }}</span>
          </h2>
          <p>{{ $t('入力した内容はすべてお使いの端末上で RSA-2048 と AES-256 により暗号化されてから送信されます。医療機関のスタッフのみが復号できます (開発者を含む第三者は閲覧できません)。') }}</p>
        </section>

        <section>
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-globe text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('多言語対応') }}</span>
          </h2>
          <p>{{ $t('右上の地球儀ボタンで 100 以上の言語に切り替えできます。入力した内容は日本語に逆翻訳されてから暗号化されるので、医療機関側は日本語で受け取れます。') }}</p>
        </section>

        <section>
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-camera text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('写真・署名') }}</span>
          </h2>
          <p>{{ $t('カメラアクセスを許可すると、保険証や患部の撮影ができます。署名欄ではタッチペンや指で署名できます。画像は SHA-256 ハッシュで改ざん検知されます。') }}</p>
        </section>

        <section>
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-clock-rotate-left text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('送信履歴') }}</span>
          </h2>
          <p>{{ $t('右上の時計アイコンから、過去に送信した問診票の一覧を確認できます (この端末でのみ保存されます)。') }}</p>
        </section>

        <section class="border-t pt-4">
          <h2 class="font-bold text-q4cl-primary mb-1 flex items-center gap-2">
            <i class="fa-solid fa-circle-question text-q4cl-accent" aria-hidden="true"></i>
            <span>{{ $t('困ったときは') }}</span>
          </h2>
          <p>{{ $t('医療機関の窓口へお声がけください。アプリの不具合は support@emuyn.net へご連絡ください。') }}</p>
        </section>
      </div>
      <!-- 末尾にも戻るボタンを置いて長文後でも閉じやすく (context があるときのみ) -->
      <div v-if="hasContext" class="mt-6 pt-4 border-t border-q4cl-border flex justify-end">
        <router-link
          :to="{ path: '/', query: $route.query }"
          class="btn-primary no-underline"
        >
          <i class="fa-solid fa-arrow-left mr-2" aria-hidden="true"></i>{{ $t('問診票に戻る') }}
        </router-link>
      </div>
    </q4cl-card>
  </div>
</template>

<script>
import Q4clCard from '@/components/ui/Q4clCard.vue'
export default {
  name: 'Usage',
  components: {
    'q4cl-card': Q4clCard
  },
  setup() {
    const route = VueRouter.useRoute();
    // hash か debug クエリがあれば「問診票閲覧中からの遷移」 と判定
    const hasContext = Vue.computed(() => !!(route.query.hash || route.query.debug));
    return { hasContext };
  }
};
</script>
